import { createSlice } from '@reduxjs/toolkit';

// initial state

// initial state
export const initialState = {
  columnsVisibility: {
    onechips: {
      eid: true,
      imsi: true,
      iccid: false,
      fallbackImsi: false,
      fallbackIccid: false,
      bootstrapImsi: false,
      bootstrapIccid: false,
      storeUnitSku: false,
      planName: true,
      pendingPlanName: false,
      deviceGroupName: true,
      deviceName: true,
      clientTitle: false,
      deviceStatus: true,
      appInstallStatus: true,
      euiccOperationStatus: false,
      euiccOperationDescription: false,
      lastEsimHeartbeat: false,
      privateBootstrapIp: false,
      privateOperationalIp: false,
      publicBootstrapIp: false,
      publicOperationalIp: false,
      totalConsumption: true,
    },
    feed: {
      eid: true,
      correlationId: true,
      notificationSubType: true,
      euiccStatus: true,
      createdAt: true,
      parameters: true,
      planName: true,
      profileImsi: true,
      profileIccid: false,
      operationStatus: true,
      error: true,
      originType: false,
      originUser: false,
      connectionPoolName: false,
      message: false,
    },
    feedDetails: {
      correlationId: true,
      notificationSubType: true,
      euiccStatus: true,
      createdAt: true,
      parameters: true,
      planName: true,
      profileImsi: true,
      profileIccid: false,
      operationStatus: true,
      error: true,
      originType: false,
      originUser: false,
      connectionPoolName: false,
      message: false,
    },
  },
  columnsWidth: {
    onechips: {},
    feed: {},
    feedDetails: {},
  },
};

const config = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setColumnsVisibility(state, action) {
      const { name, list } = action.payload;
      state.columnsVisibility = { ...state.columnsVisibility, [name]: { ...state.columnsVisibility[name], ...list } };
    },
    setColumnsWidth(state, action) {
      const { name, list } = action.payload;
      state.columnsWidth = { ...state.columnsWidth, [name]: { ...state.columnsWidth[name], ...list } };
    },
  },
});

export default config.reducer;

export const { setColumnsVisibility, setColumnsWidth } = config.actions;
